<template>
  <div id="Akcesoria">
    <!-- <h4>Dane wejściowe</h4> -->
    <form>
      <div class="form-group">
        <label for="kolka">{{ $t("message.wheels") }}</label>
        <input type="checkbox" class="form-control form-control-sm" id="kolka"
        v-model="inputData.kolka.value"
        :true-value="1"
        :false-value="0"
        @change="changeInputs('kolka')">
      </div>
      <div class="form-group">
        <label for="wentylator">{{ $t("message.fan") }}</label>
        <input type="checkbox" class="form-control form-control-sm" id="wentylator"
        v-model="inputData.panel_wentylacyjny.value"
        :true-value="1"
        :false-value="0"
        :disabled = !check_wentylator
        @change="changeInputs('panel_wentylacyjny')">
      </div>

      <div class="form-group">
        <md-avatar>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right: 0px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
          </svg>
          <md-tooltip md-direction="right" class="tooltipImg" style="">
            <h4 style="font-size: 15px;padding: 4px;" v-html="$t('message.DSOS24V_PRA_info')"></h4>
            <img src="../assets/wariant2.jpg"/>
          </md-tooltip>
        </md-avatar>
        <label for="wariant2" class="wariant-label">{{ $t("message.DSOS24V_PRA") }}</label>
        <input type="number" class="form-control form-control-sm wariant-input" id="wariant2"
        :min="inputs.wariant2.min"
        :max="inputs.wariant2.max"
        v-model="inputData.wariant2.value"
        @change="changeInputs('wariant2')"
        name="wariant2" @input="addEvent">
      </div>

      <div class="form-group">
        <md-avatar>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right: 0px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
          <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
          </svg>
          <md-tooltip md-direction="right" class="tooltipImg" style="">
            <h4 style="font-size: 15px;padding: 4px;">{{ $t("message.DSOS24VPU_info") }}</h4>
            <img src="../assets/wariant3.jpg"/>
          </md-tooltip>
        </md-avatar>
        <label for="wariant3" class="wariant-label">{{ $t("message.DSOS24VPU") }}</label>
        <input type="number" class="form-control form-control-sm wariant-input" id="wariant3"
        :min="inputs.wariant3.min"
        :max="inputs.wariant3.max"
        v-model="inputData.wariant3.value"
        @change="changeInputs('wariant3')"
        name="wariant3" @input="addEvent">
      </div>
      <!-- <div class="form-group" v-if="inputs.wariant3.value>0">
        <label for="wariant3" class="wariant-label" style="text-align: right; padding-right: 10px;">{{ $t("message.extension") }}</label>
        <input v-if="inputs.wariant3.value>0"
        type="number" class="form-control form-control-sm wariant-rozszerzenia-input" id="wariant3_rozszerzenia"
        :min="inputs.wariant3_rozszerzenia.min"
        :max="inputs.wariant3_rozszerzenia.max"
        v-model="inputData.wariant3_rozszerzenia.value"
        @change="changeInputs('wariant3_rozszerzenia')"
        name="wariant3_rozszerzenia" @input="addEvent">
      </div> -->
      <div class="form-group">
        <label for="obudowa_plytki">{{ $t("message.enclosure_loudspeaker") }}</label>
        <input type="number" class="form-control form-control-sm"  id="obudowa_plytki"
        :min="inputs.obudowa_plytki.min"
        :max="inputs.obudowa_plytki.max"
        v-model="inputData.obudowa_plytki.value"
        @change="changeInputs('obudowa_plytki')"
        name="obudowa_plytki" @input="addEvent">
      </div>

      <div class="form-group">
        <label for="polka">{{ $t("message.shelf") }}</label>
        <input type="checkbox" class="form-control form-control-sm" id="polka"
        v-model="inputData.polka_mikrofon.value"
        :true-value="1"
        :false-value="0"
        @change="changeInputs('polka_mikrofon')">
      </div>
      <!-- <div class="form-group" style="height: auto;font-size: 13.5px;">
        <table id="tabCluster">
          <tr>
            <td>{{ $t("message.callStationDesktop") }} - PRA-CSLD</td>
            <td class="qty-content">
              <input type="number" class="form-control form-control-sm" :min="inputData.csDesktop.min" :max="(outputs.qtyClusters.value * inputData.csDesktop.max)"
              v-model.lazy="inputData.csDesktop.value" @change="setCallStationElements(), changeInputs('csDesktop')" name="csDesktop" @input="addEvent">
            </td>
          </tr>
          <tr>
            <td>{{ $t("message.callStationWall") }} - PRA-CSLW</td>
            <td class="qty-content">
              <input type="number" class="form-control form-control-sm" :min="inputData.csWall.min" :max="(outputs.qtyClusters.value * inputData.csWall.max)"
              v-model.lazy="inputData.csWall.value" @change="setCallStationElements(), changeInputs('csWall')" name="csWall" @input="addEvent">
            </td>
          </tr>
          <tr>
            <td>{{ $t("message.callStationExt") }} - PRA-CSE</td>
            <td class="qty-content">
              <input type="number" class="form-control form-control-sm" min=0 :max="(outputs.qtyClusters.value * maxExt)"
              v-model.lazy="inputData.csExt.value" @change="setCallStationElements(), changeInputs('csExt')" name="csExt" @input="addEvent">
            </td>
          </tr>
          <tr>
            <td>{{ $t("message.totalPoeCST") }}</td>
            <td class="qty-content">
              <input type="number" class="form-control form-control-sm" :min="minPoE" :max="(outputs.qtyClusters.value * maxPoE)"
              v-model.lazy="inputData.poePorts.value" @change="setCallStationElements(), changeInputs('poePorts')" name="poePorts" @input="addEvent">
            </td>
          </tr>
          <tr>
            <td>{{ $t("message.classEmerdencyCST") }}</td>
            <td class="qty-content">
              <input type="number" class="form-control form-control-sm" min=0 :max="(outputs.qtyClusters.value * maxCst)"
              v-model.lazy="inputData.cstEmergency.value" @change="setCallStationElements(), changeInputs('cstEmergency')" name="cstEmergency" @input="addEvent">
            </td>
          </tr>
          <tr class="wiersz-pusty"></tr>
        </table>
      </div> -->

      <!-- <div class="form-group">
        <label for="drzwi">Drzwi w szafie</label>
        <input type="checkbox" class="form-control form-control-sm" id="drzwi"
        v-model="inputData.szafa_drzwi.value"
        :true-value="1"
        :false-value="0"
        @change="changeInputs('szafa_drzwi')">
      </div> -->

      <!-- <CallStation @allValues = checkCallStation :values="(openFile) ? clusterOne.callStation : null" :clear='clear' :title='$t("message.callStation")'/> -->
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'
// import CallStation from './Devices/CallStation'

export default {
  name: 'Akcesoria',
  mixins: [app, materials, calculation],
  components: {
    // CallStation
  },
  data () {
    return {
      inputData: {
        kolka: { 'value': 0, 'min': 0, 'max': 1 },
        // szafa_drzwi: { 'value': 1 },
        polka_mikrofon: {'value': 0},
        panel_wentylacyjny: { 'value': 1, 'min': 0, 'max': 1 },
        wariant2: { 'value': 0, 'min': 0, 'max': 16 },
        wariant2_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
        wariant3: { 'value': 0, 'min': 0, 'max': 16 },
        wariant3_rozszerzenia: { 'value': 0, 'min': 0, 'max': 32 },
        obudowa_plytki: { 'value': 0, 'min': 0, 'max': 1000 }
        // csDesktop: { 'value': 0, 'min': 0, 'max': 2 },
        // csWall: { 'value': 0, 'min': 0, 'max': 2 },
        // csExt: { 'value': 0, 'min': 0, 'max': 0 },
        // poePorts: { 'value': 0, 'min': 0, 'max': 0 },
        // cstEmergency: { 'value': 0, 'min': 0, 'max': 0 }
      }
    }
  },
  computed: {
    ...mapGetters('app', ['clearing']),
    ...mapGetters('app', ['config']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['clusterOne']),
    ...mapGetters('app', ['clusterTwo']),
    ...mapGetters('app', ['clusterThree']),
    ...mapGetters('app', ['clusterFour']),
    ...mapGetters('app', ['clusterFive']),
    ...mapGetters('app', ['clusterSix']),
    ...mapGetters('products', ['ListaSzafy']),
    ...mapGetters('products', ['ListaBosch']),
    ...mapGetters('products', ['ListaPulsar']),
    ...mapGetters('products', ['ListaAkumulatory']),
    ...mapGetters('products', ['ListaMaterialy']),
    check_depth () {
      return this.inputs.glebokosc.value > 1 ? 0 : 1
    },
    check_wentylator () {
      return (this.outputs.szafa && this.outputs.szafa.attributes.wysokosc > 24) ? 0 : 1
    }
    // maxExt () {
    //   return (Number(this.inputData.csDesktop.value) + Number(this.inputData.csWall.value)) * 4
    // },
    // minPoE () {
    //   return (Number(this.inputData.csDesktop.value) + Number(this.inputData.csWall.value))
    // },
    // maxPoE () {
    //   return (Number(this.inputData.csDesktop.value) + Number(this.inputData.csWall.value)) * 2
    // },
    // maxCst () {
    //   return (Number(this.inputData.csDesktop.value) + Number(this.inputData.csWall.value))
    // }
  },
  watch: {
    inputs: {
      deep: true, // <!-- This is important;
      handler (newValue) {
        Object.keys(this.inputData).forEach(element => {
          this.inputData[element].value = newValue[element].value
        })
      }
    },
    clearing (newValue) {
      if (newValue === true) {
        this.inputData.kolka.value = 0
        this.inputData.polka_mikrofon.value = 0
        this.inputData.panel_wentylacyjny.value = 1
        this.inputData.wariant2.value = 0
        this.inputData.wariant2_rozszerzenia.value = 0
        this.inputData.wariant3.value = 0
        this.inputData.wariant3_rozszerzenia.value = 0
        this.inputData.obudowa_plytki.value = 0

        // this.inputData.csDesktop.value = 0
        // this.inputData.csWall.value = 0
        // this.inputData.csExt.value = 0
        // this.inputData.poePorts.value = 0
        // this.inputData.cstEmergency.value = 0
      }
    }
  },
  methods: {
    addEvent ({ type, target }) {
      if (target.max) {
        if (Number(target.max) < Number(target.value)) {
          target.value = target.max
          this.inputData[target.name].value = target.max
        }
      }
    },
    changeDepthCabinet () {
      var glebokosc = this.inputData.glebokosc_szafy.value
      var wysokosc = this.outputs.szafa.attributes.wysokosc
      var matchSzafa = []
      matchSzafa = this.ListaSzafy.filter(item => (item.attributes.wysokosc === wysokosc && item.attributes.glebokosc === glebokosc))
      this.changeValueOutputs('szafa', 'array', matchSzafa[0])
      //           this.changeValueOutputs('szafa_wolne_miejsce', 'value', wolneMiejsce)
      console.log('Akcesoria - changeDepthCabinet')
      this.obliczenia_sprzetowe()
    }
    // setCallStationElements () {
    //   this.checkCallStation(this.inputData.csDesktop.value, this.inputData.csWall.value, this.inputData.csExt.value, this.inputData.poePorts.value, this.inputData.cstEmergency.value)
    // }
  }
}
</script>

<style scoped>
  form {
    width:420px
  }
  form .form-group {
    width:100%
  }
  form .form-group label {
    width: 350px
  }
  form .form-group select {
    width: 70px
  }
  form .form-group div {
    margin-right: 0px;
  }
  .md-avatar {
      width: 0px;
      min-width: 20px;
      height: 28px;
      border-radius: 0px;
  }

  .tooltipShort  {
    padding:10px;
    width:235px;
    height:65px;
    font-size: 14px;
  }
  .wariant-label {
    width:74px;
  }
  .wariant-input {
    /* position: relative;
    left: -48px;
    top: 4px;*/
    width:70px
  }
  .wariant-rozszerzenia-input {
    /* position: relative;
    right: 2px;
    top: 4px; */
    width: 70px;
  }
  .wariant-span {
    font-size: 13px;
    margin: 0px 12px;
  }
.md-tooltip {
transition-delay: 0ms;
width: 568px;
position: fixed !important;
height: 440px;
top: 25vh;
left: 172px;
}
</style>



// WEBPACK FOOTER //
// src/components/Akcesoria.vue